//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment-timezone'

export default {
  props: {
    start: Date,
    end: Date,
    timezone: String,
    showTime: Boolean,
    showDate: Boolean,
    showTimezone: Boolean,
  },
  methods: {
    formatRange(startFormat, endFormat) {
      let formatted = this.startM.format(startFormat);

      if (endFormat) {
        formatted += ' - ' + this.endM.format(endFormat);
      }

      return formatted;
    },
  },
  computed: {
    startM() {
      return moment(this.start).tz(this.timezone);
    },
    endM() {
      return moment(this.end).tz(this.timezone);
    },
    dates() {
      let start = this.startM;
      let end = this.endM;

      if (start.format('YYYY') != end.format('YYYY')) {
        return this.formatRange('MMMM D YYYY', 'MMMM D YYYY');
      }
      else if (start.format('MMMM') != end.format('MMMM')) {
        return this.formatRange('MMMM D', 'MMMM D');
      }
      else if (start.format('D') != end.format('D')) {
        return this.formatRange('MMMM D', 'D');
      }
      else {
        return this.formatRange('dddd D MMMM');
      }
    },
    times() {
      if (this.start.getTime() != this.end.getTime()) {
        return this.formatRange('h:mma', 'h:mma');
      }
      else {
        return this.formatRange('h:mma');
      }
    },
    timezoneAbbr() {
      return this.startM.format('z');
    },
  }
}



// WEBPACK FOOTER //
// ./app/components/atoms/date-range/date-range.vue